module.exports = __webpack_public_path__ + "img/selected4-min.cd7de2aa.png";